//@ts-nocheck
import { Node } from 'tiptap'

export default class Video extends Node {
  get name() {
    return 'video'
  }

  get schema() {
    return {
      block: true,
      inline: false,
      attrs: {
        controls: { default: '' },
        playsinline: { default: '' },
        preload: { default: 'metadata' },
      },
      content: 'source',
      group: 'block',
      parseDOM: [
        {
          tag: 'video',
          getAttrs: dom => ({
            controls: dom.controls,
            playsinline: dom.playsinline,
            preload: dom.preload,
          }),
        },
      ],
      toDOM: node => ['video', node.attrs, 0],
    }
  }

  commands({ schema, type }) {
    return attrs => (state, dispatch) => {
      const { tr, selection } = state
      const pos = selection.$cursor ? selection.$cursor.pos : selection.$to.pos

      const node = type.create(null, [
        schema.nodes.source.create({
          src: attrs.src,
          type: attrs.type,
        }),
      ])

      dispatch(tr.insert(pos - 1, node))
    }
  }
}
